import { createSelector } from 'reselect'
import { List } from 'immutable'

import { ATTRIB_TYPES } from './constants'

export const root = state => state.get('account')
export const attribsRoot = createSelector(root, root => root.get('attribs'))

export const attribs = createSelector(
  attribsRoot,
  attribsRoot => attribsRoot.get('attribs', List())
)

export const teamMemberAttribs = createSelector(
  attribs,
  attribs => attribs.filter(attrib => attrib.type === ATTRIB_TYPES.TEAMMEMBER)
)


export const getAccountSegments = state => root(state).getIn(['segments', 'accountSegments'])
export const getAccountSegmentsIsLoading = state => root(state).getIn(['segments', 'loading'])


// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/selectors.js